import { Component, ComponentRef, TemplateRef, ViewChild, ViewContainerRef } from "@angular/core";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { TosTableComponent } from "../tos-table/tos-table.component";
import { TableMenuOption, TableMeta } from "../../models/table-meta.interface";
import ShippingBillListingPageConfig from "./config/ShippingBillListingPage.config.json";
import LeoUpdateEditableTableConfig from "./config/LeoUpdateEditableTable.config.json";
import { TableListRequest } from "../../models/table-list-request.interface";
import { PaginatedListDataResponse } from "../../models/paginated-list-data-response";
import { LoadingService } from "../../services/loading.service";
import { ToasterService } from "../../services/toaster.service";
import { ActivatedRoute, Router } from "@angular/router";
import { RightPanelComponent } from "../right-panel/right-panel.component";
import { AutocompleteDropdownComponent } from "../autocomplete-dropdown/autocomplete-dropdown.component";
import { FormsModule } from "@angular/forms";
import { ShippingBill } from "../../models/shipping-bill.interface";
import { EditableTableComponent } from "../editable-table/editable-table.component";
import { EditableTableHeader } from "../../models/editable-table-header.interface";
import { CommonUtils } from "../../utils/common-utils";
import { InventoryService } from "../../services/inventory-service";

@Component({
  selector: 'app-shipping-bill',
  standalone: true,
  imports: [
    SvgIconComponent,
    TosTableComponent,
    AutocompleteDropdownComponent,
    FormsModule,
    EditableTableComponent
  ],
  templateUrl: './shipping-bill.component.html',
  styleUrl: './shipping-bill.component.scss'
})
export class ShippingBillComponent {
  tableMeta: TableMeta = ShippingBillListingPageConfig.listingTableConfig;
  rowsPerPage: number = 10;
  currentPage: number = 0;
  tableListRequest: TableListRequest = {
    limit: this.rowsPerPage,
    page: this.currentPage,
    includeTotal: true,
    where: ShippingBillListingPageConfig.defaultFilters
  };
  tableListData: PaginatedListDataResponse = {
    totalCount: 0,
    page: 0,
    limit: 0,
    records: []
  };
  menuOptions: TableMenuOption[] = [
    { label: "Edit", value: "edit" },
    { label: "View", value: "view" }
  ];
  selectedItems: any[] = [];

  //LEO UPDATE
  editableTableMetaForLeoUpdate: EditableTableHeader[] = LeoUpdateEditableTableConfig;
  searchAndAddText: string = "";
  selectedLeoUpdateShippingBill: ShippingBill | undefined;
  shippingBillsForLeoUpdate: ShippingBill[] = [];
  rightPanelComponentComponentRef!: ComponentRef<RightPanelComponent>

  @ViewChild("leoUpdateTemplate") leoUpdateTemplate!: TemplateRef<any>;

  protected readonly ShippingBillListingPageConfig = ShippingBillListingPageConfig;

  constructor(private loadingService: LoadingService,
              private inventoryService: InventoryService,
              private toasterService: ToasterService,
              private router: Router,
              private route: ActivatedRoute,
              private viewContainerRef: ViewContainerRef) {
  }

  ngOnInit() {
    // this.getTableList()
  }

  getTableList() {
    this.loadingService.show('inline')
    this.inventoryService.listShippingBill(this.tableListRequest).subscribe({
      next: (res: any) => {
        console.log(res);
        this.tableListData = res.data
        this.loadingService.hide()
      },
      error: (err) => {
        console.error(err);
        this.loadingService.hide()
        this.toasterService.error(err.error.errorDesc);
      }
    });
  }

  handleOptionSelected(event: any) {
    console.log(event);
    if(event.actionName === "view") {
      this.router.navigate(["view", event.record?.id], {relativeTo: this.route});
    }else if(event.actionName === "edit") {
      this.router.navigate(["edit", event.record?.id], {relativeTo: this.route});
    }
  }

  addNewShippingBill() {
    this.router.navigate(["add-new"], {relativeTo: this.route});
  }

  //LEO UPDATE
  openRightPanelForLeoUpdate() {
    this.rightPanelComponentComponentRef = this.viewContainerRef.createComponent(RightPanelComponent);
    this.rightPanelComponentComponentRef.instance.title = "Update LEO";
    this.rightPanelComponentComponentRef.instance.showActionBtns = true;

    this.rightPanelComponentComponentRef.instance.loadComponent(this.leoUpdateTemplate)

    this.rightPanelComponentComponentRef.instance.close.subscribe(()=>{
      this.resetLeoUpdateData();
      this.rightPanelComponentComponentRef.destroy()
    })

    this.rightPanelComponentComponentRef.instance.primaryActionBtnEmitter.subscribe(()=>{
      this.callApiToUpdateLeo();
    })
  }

  private resetLeoUpdateData() {
    this.searchAndAddText = "";
    this.selectedLeoUpdateShippingBill = undefined;
    this.shippingBillsForLeoUpdate = [];
  }

  handleBulkDelete(event: any) {
    this.shippingBillsForLeoUpdate.splice(event.rowIndex, 1);
  }

  selectShippingBillForLeoUpdate(event: any) {
    const shippingBillData = {
      ...event,
      pcinNo: event.exportCargoMetadata?.pcinNo,
      leoDate: event.exportCargoMetadata?.leoDate,
      leoReferenceNumber: event.exportCargoMetadata?.leoReferenceNumber,
      leoNumber: event.exportCargoMetadata?.leoNo,
    }
    shippingBillData.exportCargoMetadata.invoiceDate = CommonUtils.formatData(event?.exportCargoMetadata?.invoiceDate, "DATETIME");
    this.selectedLeoUpdateShippingBill = shippingBillData
  }

  addShippingBillForLeoUpdate() {
    if (this.selectedLeoUpdateShippingBill) {
      this.shippingBillsForLeoUpdate.push(this.selectedLeoUpdateShippingBill);
    }

    this.searchAndAddText = "";
    this.selectedLeoUpdateShippingBill = undefined;
  }

  getAddedShippingBillsDocumentNo() {
    const documentNumbers = this.shippingBillsForLeoUpdate.map(item => item.documentNo);
    return documentNumbers.length === 0 ? [''] : documentNumbers
  }

  private callApiToUpdateLeo() {
    this.loadingService.show()
    const leoUpdateRequestList = this.shippingBillsForLeoUpdate.map(bill => {
      return {
        shippingBillId: bill.id,
        pcinNumber: bill.pcinNo,
        leoNumber: bill.leoNumber,
        leoDate: bill.leoDate,
        referenceNumber: bill.leoReferenceNumber
      }
    });
    this.inventoryService.updateLeo({"leoUpdateRequestList": leoUpdateRequestList}).subscribe({
      next: (res) => {
        this.rightPanelComponentComponentRef.destroy()
        this.resetLeoUpdateData();

        this.toasterService.success("LEO updated successfully");
        this.loadingService.hide();
      },
      error: (err) => {
        this.loadingService.hide();
        this.toasterService.error(err.error.errorDesc);
      }
    })
  }
}
